import type { QueryClient } from '@tanstack/react-query';
import { getAuthtoken, getSelectedOrganizationId } from 'stores/useAuthStore';
import { baseViewSchemaQueryOptions } from 'containers/Base/useSchemaQuery';
import { resourcesQueryOptions } from 'containers/Resources/hooks/useResources';
import { deviceGroupsQueryOptions } from 'containers/DeviceGroups/hooks/useDeviceGroups';


function hasSelectedOrg(): boolean {
  return Number.isFinite(getSelectedOrganizationId());
}

export function prefetchGridSchema(queryClient: QueryClient, itemType: string) {
  const authToken = getAuthtoken();
  if (!authToken || !hasSelectedOrg()) return;
  queryClient.prefetchQuery(
    baseViewSchemaQueryOptions(
      itemType,
      authToken,
      getSelectedOrganizationId(),
      true
    )
  );
}

export function prefetchDashboardData(queryClient: QueryClient) {
  const authToken = getAuthtoken();
  if (!authToken || !hasSelectedOrg()) return;
  const orgId = getSelectedOrganizationId();
  queryClient.prefetchQuery(resourcesQueryOptions(authToken, orgId));
  queryClient.prefetchQuery(deviceGroupsQueryOptions(authToken, orgId));
}
